"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkGeneratorApiClient = exports.lookupPath = exports.generateLinkPath = void 0;
const base_client_1 = require("@soluto-private/base-client");
exports.generateLinkPath = "/generateLink";
exports.lookupPath = "/lookup";
class LinkGeneratorApiClient extends base_client_1.BaseApiClient {
    generateLink() {
        return this.get(exports.generateLinkPath);
    }
    lookup(uuid) {
        return this.get(`${exports.lookupPath}/${uuid}`);
    }
}
exports.LinkGeneratorApiClient = LinkGeneratorApiClient;
//# sourceMappingURL=LinkGeneratorApiClient.js.map